"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var utils = {
  sum: function sum(array) {
    return array.reduce(function (a, b) {
      return a + b;
    });
  }
};
var _default = utils;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/distinct-colors/lib/utils.js
// module id = 2720
// module chunks = 6